/**
 * The application wizard's step gutter — one string, two consumers.
 *
 * `ApplicationWizard` has always wrapped its steps in `max-w-2xl mx-auto px-4
 * py-6 space-y-4`, and the family-wording preview rendered two of those steps
 * (`DocumentUploadStep`, `ReviewSummary`) with none of it: the components are
 * the real ones, but a step body without the container it lives in is not the
 * screen a family sees. In a 393px frame the result was text flush to both
 * edges with no gutter and no vertical rhythm, against five sibling screens
 * that render through `AuthShell` and look finished — the "does not match the
 * rest of the screens" report of 2026-08-30 (B-570).
 *
 * It lives here rather than in the wizard so the preview does not import a
 * page, and as a CONSTANT rather than two copies so the preview cannot drift
 * from the thing it claims to be previewing. `copy-preview-gutter.test.tsx`
 * pins that both use it.
 *
 * #2448: wider (`3xl`) and with no top padding — the step starts level with
 * the header toolbar, and the wizard sets its progress beside it from `lg` up.
 */
export const WIZARD_STEP_CONTAINER = 'max-w-3xl mx-auto px-4 pb-6 space-y-4';
